/* eslint-disable camelcase */
import { useApiSignupStatusList } from 'state/__generated__/tadaahAPI';

import useIsFreelancerLoggedIn from 'hooks/use-is-freelancer-logged-in';

type SignupStatus = 'completed' | 'not-completed' | undefined;

export type FreelancerSignupStatusResult = {
  fillInformationComplete: boolean;
  fullName: string | undefined;
  verified: boolean | undefined;
  personalInformation: SignupStatus;
  KVKInformation: SignupStatus;
  documents: SignupStatus;
  diplomas: SignupStatus;
};

type UseGetFreelancerSignupHandler = {
  data: FreelancerSignupStatusResult | undefined;
  error: string | undefined;
  isLoading: boolean;
  isSuccess: boolean;
};

const useGetFreelancerSignupStatus = (): UseGetFreelancerSignupHandler => {
  const isLoggedIn = useIsFreelancerLoggedIn();

  const { data, error, isLoading, isSuccess } = useApiSignupStatusList({
    query: {
      enabled: isLoggedIn,
      queryKey: 'freelancer-signup-status',
    },
  });

  const percentageCompletedToString = (percentage: number | undefined) => {
    switch (percentage) {
      case 100:
        return 'completed';
      default:
        return 'not-completed';
    }
  };

  const apiData = data?.data;
  const personalInformation = percentageCompletedToString(
    apiData?.personal_info_percent,
  );
  const KVKInformation = percentageCompletedToString(
    apiData?.kvk_registration_percent,
  );
  const diplomas = percentageCompletedToString(
    apiData?.diplomas_certificates_percent,
  );
  const documents = percentageCompletedToString(apiData?.documents_percent);

  const fillInformationComplete: boolean =
    personalInformation === 'completed' &&
    KVKInformation === 'completed' &&
    documents === 'completed' &&
    diplomas === 'completed';

  const result: FreelancerSignupStatusResult = {
    diplomas,
    documents,
    fillInformationComplete,
    fullName: apiData?.full_name,
    KVKInformation,
    personalInformation,
    verified: apiData?.verified,
  };

  return {
    data: result,
    error: error?.message,
    isLoading,
    isSuccess,
  };
};

export default useGetFreelancerSignupStatus;
